import API_PATH from '@/constants/apiPath'
import Toastr from 'toastr'
import { downloadURL } from '@/utils/index'

const state = {
    ctaList: [],
    bulkctaList: [],
    totalUploads: 0,
    identifiers: []
}
const getters = {
    getTableData: (state) => state.ctaList,
    getbulkCtaList: (state) => state.bulkctaList,
    getTotalUploads: (state) => state.totalUploads,
    getIdentifiers: (state) => state.identifiers
}
const mutations = {
    SET_TABLE_DATA (state, payload) {
        state.ctaList = payload
    },
    SET_BULK_WHITELIST (state, payload) {
        state.bulkctaList = payload.data
        state.totalUploads = parseInt(payload.total.counts)
    },
    SET_IDENTIFIERS (state, payload) {
        state.identifiers = payload
    }
}
const actions = {
    async whitelist ({ commit }, payload) {
        try {
            const resp = await this.$axios.post(API_PATH.cta.set, payload)
            if (resp && resp.data && resp.data.displayMsg && resp.data.displayMsg.s) {
                Toastr.success(resp.data.displayMsg.s.head, resp.data.displayMsg.s.msg)
                return true
            }
            return false
        } catch (err) {
            console.log(err)
        }
    },
    async fetchCtas ({ commit }, payload) {
        try {
            const resp = await this.$axios.post(API_PATH.cta.get, payload)
            commit('SET_TABLE_DATA', resp.data)
        } catch (err) {
            console.log(err)
        }
    },
    async fetchIdentifiers ({ commit }, payload) {
        try {
            const resp = await this.$axios.post(API_PATH.cta.identifiers, payload)
            commit('SET_IDENTIFIERS', resp.data)
        } catch (err) {
            console.log(err)
        }
    },
    async downloadAllCtas ({ commit }, payload) {
        try {
            const response = await this.$axios.post(`${API_PATH.cta.downloadAll}`, payload)
            return response
        } catch (error) {
            Toastr.error(`Error downloading file`, 'Error')
        }
    },
    async downloadSampleFile ({ commit }, payload) {
        const fileUrl = payload.url
        await fetch(fileUrl).then(response => {
            return response.blob()
        }).then(blob => {
            const url = window.URL.createObjectURL(blob)
            downloadURL(url, '_blank', payload.name)
        })
    },
    async uploadFile ({ commit }, { file, type, uploadName, subTypeForCta, urlFileType }) {
        let formData = new FormData()
        formData.append('file', file)
        formData.append('type', type)
        formData.append('status', 1)
        if (type === 'url') {
            formData.append('subType', urlFileType)
        }
        formData.append('uploadName', uploadName)
        formData.append('subTypeForCta', subTypeForCta)

        try {
            const response = await this.$axios.post(API_PATH.cta.bulkUpload, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            })
            return response
        } catch (error) {
            Toastr.error(`Error uploading file`, 'Error')
        }
    },
    async getBulkUploadsList ({ commit }, payload) {
        console.log('getBulkUploadsList')
        try {
            const response = await this.$axios.post(API_PATH.cta.bulkGet, payload)
            commit('SET_BULK_WHITELIST', response.data)
        } catch (error) {
            Toastr.error(`Error uploading file`, 'Error')
        }
    },
    async downloadFile ({ commit }, payload) {
        try {
            const response = await this.$axios.post(`${API_PATH.cta.bulkFileDownload}`, payload)
            return response
        } catch (error) {
            Toastr.error(`Error downloading file`, 'Error')
        }
    }
}

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
}
